import { render, staticRenderFns } from "./ViewBody.vue?vue&type=template&id=7bb9c458&scoped=true&"
import script from "./ViewBody.vue?vue&type=script&lang=js&"
export * from "./ViewBody.vue?vue&type=script&lang=js&"
import style0 from "./ViewBody.vue?vue&type=style&index=0&id=7bb9c458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9c458",
  null
  
)

export default component.exports